module.exports = __webpack_public_path__ + "static/media/full-screen-image-3.ef9c8d65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/full-screen-image-3.jpg
// module id = 497
// module chunks = 0